import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import magnifierIcon from 'assets/img/icons/magnifier.svg';
import { FormGroup } from 'reactstrap';
import { debounce } from 'lodash';
import { setSearchQuery } from './SearchActions';
import CommonInput from '../common/components/CommonInput';

const SearchForm = () => {
  const dispatch = useDispatch();
  const [value, setValue] = useState('');

  const debounceSearch = useCallback(
    debounce(value => {
      dispatch(setSearchQuery(value, true));
    }, 1000),
    [],
  );

  const handleChange = e => {
    setValue(e.target.value);
    debounceSearch(e.target.value);
  };

  return (
    <>
      <FormGroup className="m-0">
        <CommonInput
          onChange={handleChange}
          placeHolder="Search"
          icon={magnifierIcon}
          iconClassName="search-icon"
          value={value}
        />
      </FormGroup>
    </>
  );
};

export default SearchForm;
